var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutWork1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 92,
    viewBox: "0 0 90 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kickstart",
    clipPath: "url(#clip0_3_965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.5383 75.2609C66.6992 80.7526 58.0929 84.0223 48.7268 84.0223C47.2247 84.0223 45.7579 83.932 44.3088 83.7694C39.0072 83.1732 36.6923 76.6519 40.4034 72.7499L58.6761 53.5653C64.2604 47.6943 67.6711 40.071 68.2013 32.2309L68.5017 27.787C68.6431 25.6554 66.8759 23.9031 64.8083 24.1018L60.4787 24.5354C52.8444 25.2941 45.4752 28.9793 39.8732 34.8503L20.381 55.3175C16.882 58.9847 10.7674 57.3046 9.61876 52.3188C8.92955 49.302 8.57617 46.1768 8.57617 42.9432C8.57617 41.4981 8.64685 40.089 8.78823 38.68",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.707 18.1225C24.2353 8.00628 36.2346 1.55719 49.7006 1.88235C71.4548 2.40622 89.0207 20.8864 88.9147 43.142C88.8793 48.8685 87.7129 54.306 85.6276 59.2557",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.6108 60.3484L5.32134 74.3766C4.54732 75.1937 4.56501 76.4945 5.36079 77.2823C6.15657 78.07 7.42908 78.0463 8.20309 77.2293L21.4926 63.2011C22.2666 62.384 22.249 61.0831 21.4532 60.2953C20.6574 59.5076 19.3849 59.5314 18.6108 60.3484Z",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.0784 66.7503L5.38384 87.5396C4.60982 88.3567 4.62752 89.6575 5.4233 90.4453C6.21907 91.233 7.49158 91.2093 8.26559 90.3923L27.9601 69.603C28.7342 68.7859 28.7165 67.485 27.9208 66.6972C27.125 65.9095 25.8524 65.9332 25.0784 66.7503Z",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.5386 73.1443L18.2492 87.1725C17.4751 87.9896 17.4928 89.2905 18.2885 90.0783C19.0843 90.866 20.3568 90.8423 21.1308 90.0252L34.4203 75.997C35.1943 75.18 35.1768 73.879 34.381 73.0912C33.5853 72.3035 32.3127 72.3273 31.5386 73.1443Z",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M50.3804 48.8706C53.352 48.8706 55.7609 46.4082 55.7609 43.3706C55.7609 40.333 53.352 37.8706 50.3804 37.8706C47.4089 37.8706 45 40.333 45 43.3706C45 46.4082 47.4089 48.8706 50.3804 48.8706Z",
    fill: "#236F5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0.978516 32.2134C0.978516 29.5218 3.09915 27.354 5.73227 27.354C8.36539 27.354 10.486 29.5218 10.486 32.2134",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.4863 32.2133C10.4863 29.5217 12.607 27.354 15.2401 27.354C17.8732 27.354 19.9938 29.5217 19.9938 32.2133",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M69.0859 69.9312C69.0859 67.2395 71.2066 65.0718 73.8397 65.0718C76.4728 65.0718 78.5935 67.2395 78.5935 69.9312",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M78.5938 69.9312C78.5938 67.2396 80.7144 65.0718 83.3475 65.0718C85.9806 65.0718 88.1012 67.2396 88.1012 69.9312",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 91,
    fill: "white",
    transform: "translate(0 0.870605)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutWork1);
export default __webpack_public_path__ + "static/media/aboutWork1.5af85b0f4d953e2d41630011e368c80d.svg";
export { ForwardRef as ReactComponent };